// @flow

import React from 'react';

import {
  LeftDownArrow,
  RightDownArrow,
  ContactForm,
  WillContactYou,
  SignMou,
  RecieveQueries,
  RecievePatients,
  PayCommission
} from '@images/svg/index';

import { HeadlineSection } from '@components/Headlines';
import {
  StyledBigNumberLeft,
  StyledSubHeadlineSection,
  StyledCover,
  StyledListItem,
  StyledHeaderSection,
  StyledArrowSnakeLeft,
  StyledArrowSnakeRight,
  StyledHorizontalArrowWrapper,
  StyledStepsDetails,
  StyledHeadingSection,
  StyledDetailSection,
  StyledStepsContainer,
  StyledSteps,
  StyledArrowStepContainer,
  StyledUpperStep,
  StyledLowerStep,
  StyledDownArrowContainer,
  SyledDownArrowStep,
  StyledMaxWidth
} from './styles';

import type { Props, StepProps } from './types';

const defaultListHeaderComponent = () => (
  <>
    <HeadlineSection>TeaserList.Headline</HeadlineSection>
    <StyledSubHeadlineSection>TeaserList.SubHeadline</StyledSubHeadlineSection>
  </>
);

const FirstStepItem = ({ headline, copy, HowItWorks }: StepProps) => (
  <StyledSteps>
    <StyledUpperStep>{HowItWorks ? <ContactForm /> : <SignMou />}</StyledUpperStep>
    <StyledLowerStep>
      <StyledBigNumberLeft>1</StyledBigNumberLeft>
      <StyledStepsDetails>
        <StyledHeadingSection>{headline}</StyledHeadingSection>
        <StyledDetailSection>{copy}</StyledDetailSection>
      </StyledStepsDetails>
    </StyledLowerStep>
  </StyledSteps>
);
const SecondStepItem = ({ headline, copy, HowItWorks }: StepProps) => (
  <StyledSteps>
    <StyledUpperStep>{HowItWorks ? <WillContactYou /> : <RecieveQueries />}</StyledUpperStep>
    <StyledLowerStep>
      <StyledBigNumberLeft>2</StyledBigNumberLeft>
      <StyledStepsDetails>
        <StyledHeadingSection>{headline}</StyledHeadingSection>
        <StyledDetailSection>{copy}</StyledDetailSection>
      </StyledStepsDetails>
    </StyledLowerStep>
  </StyledSteps>
);

const ThirdStepItem = ({ headline, copy, HowItWorks }) => (
  <StyledSteps>
    <StyledUpperStep>
      {HowItWorks ? (
        <img src="/static/images/svg/medical-visa.svg" loading="lazy" alt="Horizontal-arrow" style={{ WebkitUserDrag: 'none' }} />
      ) : (
        <RecievePatients />
      )}
    </StyledUpperStep>
    <StyledLowerStep>
      <StyledBigNumberLeft>3</StyledBigNumberLeft>
      <StyledStepsDetails>
        <StyledHeadingSection>{headline}</StyledHeadingSection>
        <StyledDetailSection>{copy}</StyledDetailSection>
      </StyledStepsDetails>
    </StyledLowerStep>
  </StyledSteps>
);
const FourthStepItem = ({ headline, copy, HowItWorks }) => (
  <StyledSteps>
    <StyledUpperStep>
      {HowItWorks ? (
        <img src="/static/images/svg/best-treatment.svg" loading="lazy" alt="Horizontal-arrow" style={{ WebkitUserDrag: 'none' }} />
      ) : (
        <PayCommission />
      )}
    </StyledUpperStep>
    <StyledLowerStep>
      <StyledBigNumberLeft>4</StyledBigNumberLeft>
      <StyledStepsDetails>
        <StyledHeadingSection>{headline}</StyledHeadingSection>
        <StyledDetailSection>{copy}</StyledDetailSection>
      </StyledStepsDetails>
    </StyledLowerStep>
  </StyledSteps>
);

const ArrowStep = () => (
  <StyledArrowStepContainer>
    <StyledUpperStep>
      <StyledHorizontalArrowWrapper>
        <img src="/static/images/svg/horizontal-through-arrow.svg" loading="lazy" alt="Horizontal-arrow" />
      </StyledHorizontalArrowWrapper>
    </StyledUpperStep>
    <StyledLowerStep />
  </StyledArrowStepContainer>
);
const ArrowStepReversed = () => (
  <StyledArrowStepContainer>
    <StyledUpperStep>
      <StyledHorizontalArrowWrapper MobileReversedArrow>
        <img src="/static/images/svg/horizontal-through-arrow.svg" loading="lazy" alt="Horizontal-arrow" />
      </StyledHorizontalArrowWrapper>
    </StyledUpperStep>
    <StyledLowerStep />
  </StyledArrowStepContainer>
);
const TeaserList = ({
  listHeaderComponent,
  images,
  headlines,
  copies,
  className,
  HowItWorks
}: Props) => {
  const ListHeaderSection = listHeaderComponent || defaultListHeaderComponent;
  return (
    <StyledMaxWidth>
      <StyledCover className={className}>
        <StyledListItem>
          <StyledArrowSnakeLeft>
            <LeftDownArrow />
          </StyledArrowSnakeLeft>
          <StyledHeaderSection>
            <ListHeaderSection />
          </StyledHeaderSection>
          <StyledArrowSnakeRight>
            <RightDownArrow />
          </StyledArrowSnakeRight>
        </StyledListItem>

        <StyledStepsContainer>
          <FirstStepItem
            headline={headlines[0]}
            copy={copies[0]}
            Image={images[0]}
            HowItWorks={HowItWorks}
          />
          <ArrowStep />
          <SecondStepItem
            headline={headlines[1]}
            copy={copies[1]}
            Image={images[1]}
            HowItWorks={HowItWorks}
          />
          <ArrowStep />
          <ThirdStepItem
            headline={headlines[2]}
            copy={copies[2]}
            Image={images[2]}
            HowItWorks={HowItWorks}
          />
          <ArrowStep />
          <FourthStepItem
            headline={headlines[3]}
            copy={copies[3]}
            Image={images[3]}
            HowItWorks={HowItWorks}
          />
        </StyledStepsContainer>
        <StyledDownArrowContainer>
          <SyledDownArrowStep>
            <StyledHorizontalArrowWrapper mobile>
              <img src="/static/images/svg/horizontal-through-arrow.svg" loading="lazy" alt="Horizontal-arrow" />
            </StyledHorizontalArrowWrapper>
          </SyledDownArrowStep>
        </StyledDownArrowContainer>

        <StyledStepsContainer MobileStepContainer>
          <FirstStepItem headline={headlines[0]} copy={copies[0]} />
          <ArrowStep />
          <SecondStepItem headline={headlines[1]} copy={copies[1]} />
          <ArrowStep />
          <ThirdStepItem headline={headlines[2]} copy={copies[2]} HowItWorks={HowItWorks} />
          <ArrowStepReversed MobileReversedArrow />
          <FourthStepItem headline={headlines[3]} copy={copies[3]} HowItWorks={HowItWorks} />
        </StyledStepsContainer>
      </StyledCover>
    </StyledMaxWidth>
  );
};

export default TeaserList;
